export default __webpack_public_path__ + "static/pragicts-cloudops-security-5a879af131c8b2dd0fdf7346dcd898bf.jpeg";